import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ReceivingShipmentService } from '../../service/api/receiving-shipment-service';

const POItemShipmentsModal = ({ show, poItemId, onClose }) => {
  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && poItemId) {
      setLoading(true);
      setShipments([]);
      ReceivingShipmentService.getShipmentsByPOQuery({ POItemId: poItemId })
        .then(response => {
          if (response.status === 200 && Array.isArray(response.response)) {
            setShipments(response.response);
          } else {
            setShipments([]);
          }
        })
        .catch(() => setShipments([]))
        .finally(() => setLoading(false));
    }
  }, [show, poItemId]);

  const handleGoToShipment = (shipmentId) => {
    window.open(`/mappings?shipmentId=${shipmentId}`, '_blank');
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Shipments for PO Item</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center p-4">Loading shipments...</div>
        ) : shipments.length === 0 ? (
          <div className="text-center p-4">No shipments found.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Shipment Number</th>
                  <th>Received Quantity</th>
                  <th>Go to Shipment</th>
                </tr>
              </thead>
              <tbody>
                {shipments.map(s => (
                  <tr key={s.receivingShipmentID}>
                    <td>{s.shipmentNumber}</td>
                    <td>{s.receivedQuantity ?? '-'}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleGoToShipment(s.receivingShipmentID)}
                      >
                        Go to Shipment
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default POItemShipmentsModal; 